/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import { Text, Tag, theme, FlexContainer } from "@nordcloud/gnui";
import { MappingRule, MappingRuleType } from "~/generated/graphql";
import {
  SmallColumn,
  MediumColumn,
  LargeIconColumn,
} from "~/components/Tables/styles";
import { DeleteMappingRule } from "./DeleteMappingRule";

const columnHelper = createColumnHelper<MappingRule>();

export function columns() {
  return [
    columnHelper.accessor((row) => row.type, {
      header: "Type",
      cell: ({ row }) => (
        <Tag
          text={
            row.original.type.charAt(0).toUpperCase() +
            row.original.type.slice(1).toLowerCase()
          }
          color={
            row.original.type === MappingRuleType.Application
              ? theme.color.support.indigo
              : theme.color.support.purple
          }
        />
      ),
      meta: LargeIconColumn,
    }),
    columnHelper.accessor((row) => row.tagName, {
      header: "Tag Key",
      cell: ({ row }) => <Text>{row.original.tagName}</Text>,
      meta: {
        css: {
          ...MediumColumn.css,
          textAlign: "left",
        },
      },
    }),
    columnHelper.accessor(() => null, {
      id: "options",
      header: () => null,
      cell: ({ row }) => {
        const mappingRuleId = row.original.id;
        const mappingRuleName = row.original.tagName;
        return (
          <FlexContainer justifyContent="flex-end">
            <DeleteMappingRule
              mappingRuleId={mappingRuleId}
              mappingRuleName={mappingRuleName}
            />
          </FlexContainer>
        );
      },
      meta: SmallColumn,
    }),
  ] as never;
}
